import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

type BottomBarReducerState = {
  bottomBarVisible: boolean;
  updateAvailable: boolean;
};

const initialState: BottomBarReducerState = {
  bottomBarVisible: false,
  updateAvailable: false,
};

const bottombarSlice = createSlice({
  name: "bottombar",
  initialState,
  reducers: {
    setUpdateAvailable(state, action: PayloadAction<boolean>) {
      state.updateAvailable = action.payload;
      state.bottomBarVisible = action.payload;
    },
  },
});

export const { setUpdateAvailable } = bottombarSlice.actions;
export const bottomBarSelector = (state: RootState) => state.bottomBarReducer;
export default bottombarSlice.reducer;
